import PageTitle from '../../components/Pagetitle/Pagetitle';
import Divider from '../../components/Divider/Divider';
import SocialCard from '../../components/SocialCard/SocialCard';
import Label from '../../components/Label/Label';
import Modal from '../../components/Modal/Modal';
import Input from '../../components/Input/Input';
import Accordion from '../../components/Accordion/Accordion';
import Vue from 'vue';
import isotope from 'vueisotope';
import imagesLoaded from 'vue-images-loaded';
import VueMasonry from 'vue-masonry-css';
import Button from '../../components/Button/Button';
import UsersTable from '../../components/tables/UsersTable/UsersTable';
import GroupTable from '@/components/tables/GroupTable';
import Composer from '@/components/Composer';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import deepmerge from 'deepmerge';
import MultiSelectSearch from '../../components/MultiSelectSearch/MultiSelectSearch';
import sort from '@/utils/Sort';
import Avatar from '@/components/Avatar/Avatar';

import Context from '@/models/Context';
import Item from '@/models/content/Item';

Vue.use(VueMasonry);

export default {
  name: 'Publish',
  components: {
    MultiSelectSearch,
    GroupTable,
    UsersTable,
    Button,
    Input,
    Accordion,
    Modal,
    PageTitle,
    Composer,
    Divider,
    SocialCard,
    Label,
    isotope,
    Avatar
  },
  directives: {
    imagesLoaded
  },
  props: [],
  data() {
    return {
      modal: {
        channels: false,
        utm: false
      },
      selectedUsers: [],
      selectedGroups: [],
      filteredChannels: [],
      isotope_option: {
        percentPosition: true,
        masonry: {
          gutter: 20,
          columnWidth: '.social-card'
        },
        hiddenStyle: {
          opacity: 0
        },
        visibleStyle: {
          opacity: 1
        }
      }
    };
  },
  computed: {
    composerItem: function() {
      const context = Context.query()
        .where(context => {
          return context.id === 'current';
        })
        .first().composerTemplate;
      return context;
    },

    filteredItems() {
      if (!this.isLoading) {
        return this.pinnedItems.filter(current => {
          return current.isPinned;
        });
      } else {
        return null;
      }
    },

    pinnedItems: function() {
      if (!this.isLoading) {
        const result = Item.query()
          .where(item => {
            return item.isPinned;
          })
          .withAllRecursive()
          .all();

        return sort(result, 'createdAtSorter', 'desc');
      } else {
        return null;
      }
    },

    isLoading: function() {
      return this._isLoading();
    }
  },
  beforeMount() {
    this._pinned();
  },
  mounted() {},
  methods: {
    ...mapActions({
      _composerTemplate: 'entities/context/composerTemplate',
      _pinned: 'entities/items/findPinned',
      _itemUnpin: 'entities/items/unpin'
    }),
    ...mapGetters({
      _isLoading: 'isLoading'
    }),
    openUtmModal: function() {},
    updateSelectedTarget() {
      let users = [this.selectedUsers];
      this.selectedGroups.forEach(group => {
        console.log(group);
        if (group.users) {
          users.push(group.users);
        }
      });
      this._updateNewPost({
        channels: deepmerge.all(users)
      });
      this.modal.channels = false;
    },
    redo() {
      this.$refs.isotope_wall.layout();
    },
    toComposer(item) {
      this._composerTemplate(item.id);
    },
    updatePin(item) {
      this._itemUnpin(item);
    }
    // fetchChannels(params){
    //     return new Promise((resolve, reject)=>{
    //         Promise.all([this._getGroups(params), this._getThemes(params), this._getActiveUsers(params)]).then((values) => {
    //             resolve([{
    //                     group: 'Groups',
    //                     prefix: 'Group: ',
    //                     values: values[0],
    //                 },
    //                 {
    //                     group: 'Themes',
    //                     prefix: 'Theme: ',
    //                     values: values[1]
    //                 },
    //                 {
    //                     group: 'Users',
    //                     prefix: 'User: ',
    //                     values: values[2]
    //                 }])
    //         });
    //     })
    // }
  }
};
